Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyFiltersView extends Backbone.View
  template: JST['backbone/templates/monitoring/survey_filters']

  events:
    'click .removeAll': 'onRemoveAllFilters'
    'click a.toggle': 'toggle'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @tagsByClientCode = @options.tagsByClientCode || []
    @filterViews = []
    @queryBackup = []

  render: ->
    @$el.html @template
    @_renderAppliedFilters()
    @_renderFilterGroups()
    @

  _renderAppliedFilters: ->
    appliedFilterViews = [
      new Surveys.Views.Filters.AppliedSurveyView(
        searchQuery: @searchQuery
      )
      new Surveys.Views.Filters.AppliedSurveyAnswerDateView(
        searchQuery: @searchQuery
      )
      new Surveys.Views.Filters.AppliedTagsView(
        searchQuery: @searchQuery
        tagsByClientCode: @tagsByClientCode
      )
      new Monitoring.Views.SocialContents.Filters.AppliedCustomFacetsView(
        searchQuery: @searchQuery
      )
      new Monitoring.Views.SocialContents.Filters.AppliedSurveyFilterView(
        searchQuery: @searchQuery
      )
    ]
    @filterViews.concat appliedFilterViews
    @$('.survey-applied-filters').append view.render().el for view in appliedFilterViews

  _renderFilterGroups: ->
    @_renderGeneralFilterGroup()
    @_renderFieldsFilterGroup()
    @_renderTextFieldsFilterGroup()

  _renderGeneralFilterGroup: ->
    filters_container = @$el.find('#filters-container')
    @renderFilterGroup
      title: I18n.t('monitoring.dashboard.filters.filter_names.surveys.general')
      filterViews: [
        new Surveys.Views.Filters.SurveyAnswerDateFilterView(
          searchQuery: @searchQuery
          filtersContainer: filters_container
        ),
        new Surveys.Views.Filters.TagsFilterView(
          searchQuery: @searchQuery
          facet: @facets
          tagsByClientCode: @tagsByClientCode
        ),
      ]

  _renderFieldsFilterGroup: ->
    @renderFilterGroup
      title: I18n.t('monitoring.dashboard.filters.filter_names.surveys.fields')
      filterViews: [
        new Monitoring.Views.SocialContents.Filters.SurveyNPSFilterView(
          searchQuery: @searchQuery
          facet: @facets
        ),
        new Monitoring.Views.SocialContents.Filters.SurveyItemFiltersView(
          searchQuery: @searchQuery
          facet: @facets
        ),
      ]

  _renderTextFieldsFilterGroup: ->
    @renderFilterGroup
      title: I18n.t('monitoring.dashboard.filters.filter_names.surveys.text_fields')
      filterViews: [
        new Monitoring.Views.SocialContents.Filters.SurveyKeywordFiltersView(
          searchQuery: @searchQuery
          facet: @facets
        ),
      ]

  renderFilterGroup: ({title, filterViews}) ->
    @filterViews.concat filterViews
    view = new Monitoring.Views.SocialContents.Filters.SurveyFilterGroupView
      title: title
      filterViews: filterViews
    @$('#survey-filter-groups-container').append view.render().el

  destroy: ->
    _.each(@filterViews, (view) -> view.destroy())
    @remove()
    return false

  toggle: (event) =>
    @constructor.toggleFilter $(event.currentTarget).closest('.filter')

  @toggleFilter: (filter) ->
    icon = filter.find('i:not(".fa")')
    filter.toggleClass 'collapsed expanded'
    icon.toggleClass 'icon-chevron-down icon-chevron-right'
    filter.find('.one-click-open').addBack('.one-click-open').click()

  onRemoveAllFilters: ->
    filters = ['date_from_realtime', 'date_from', 'date_from_ISO', 'date_to', 'date_to_ISO', 'date_now']
    @_backup(filters)
    @searchQuery.reset()
    @_restore(filters)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _backup: (filters) =>
    @queryBackup = []
    _.each(filters, (filter) => @queryBackup.push(@searchQuery.get(filter)))

  _restore: (filters) =>
    _.each(filters, (filter, index) => @searchQuery.set(filter, @queryBackup[index]))
